import { ChevronDownIcon } from '@icons';
import clsx from 'clsx';
import { useScrollObserver } from 'features/hooks/useScrollObserver';

export const HorizontalScroll = ({ children }: { children: React.ReactNode }) => {
	const { containerRef, canScrollLeft, canScrollRight, scrollLeft, scrollRight } =
		useScrollObserver<HTMLDivElement>();

	return (
		<div className="flex flex-row">
			<button
				onClick={scrollLeft}
				className={clsx(
					'p-1 rounded-full hover:bg-gray-50 self-start',
					!canScrollLeft && 'opacity-0'
				)}
			>
				<ChevronDownIcon className="text-icon-base rotate-90" />
			</button>

			<div ref={containerRef} className="pr-4 overflow-x-scroll no-scrollbar pb-4 mb-4">
				{children}
			</div>

			<button
				onClick={scrollRight}
				className={clsx(
					'p-1 rounded-full hover:bg-gray-50 self-start',
					!canScrollRight && 'opacity-0'
				)}
			>
				<ChevronDownIcon className="text-icon-base -rotate-90" />
			</button>
		</div>
	);
};
